import omit from 'lodash/omit';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const bookingStatusCountsQueryAtom = createQueryAtomFactory(
  'trade.bookingStatusCounts',
  () => ({
    bookingStatusCounts: {
      voided: true,
      draft: true,
      open: true,
      shipped: true,
      completed: true,
    },
  }),
  {
    select: ({ bookingStatusCounts }) =>
      omit(bookingStatusCounts, ['__typename']),
  },
);
